// extracted by mini-css-extract-plugin
module.exports = {"PageMessageWarning":"appointments__PageMessage__PageMessageWarning"};